import { constructGoogleImageParams } from './image.es.js';
import { MAX_DPR } from '../constants/root.es.js';

const buildSrcsetDPR = (imageUrl, absolutedWidth) => {
  if (!imageUrl)
    return "";
  if (!imageUrl.startsWith("https://lh3.googleusercontent.com/"))
    return imageUrl;
  return Array.from({ length: MAX_DPR }, (_, i) => i + 1).map(
    (dpr) => `${constructGoogleImageParams(imageUrl, {
      width: absolutedWidth * dpr,
      format: "webp"
    })} ${dpr}x`
  ).join(", ");
};

export { buildSrcsetDPR };
